'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildInitialMessage = undefined;

var _immutable = require('immutable');

var _generateUuid = require('../../common-message-format/generateUuid');

var _buildAttachments = require('../../common-message-format/operators/buildAttachments');

var _Status = require('../../common-message-format/records/Status');

var _Status2 = _interopRequireDefault(_Status);

var _timestamps = require('../../lib/timestamps');

var _InitialMessage = require('../records/InitialMessage');

var _InitialMessage2 = _interopRequireDefault(_InitialMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buildInitialMessage = exports.buildInitialMessage = function buildInitialMessage() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      id = _ref.id,
      clientType = _ref.clientType,
      sender = _ref.sender,
      status = _ref.status,
      attachments = _ref.attachments,
      _ref$richText = _ref.richText,
      richText = _ref$richText === undefined ? null : _ref$richText,
      _ref$text = _ref.text,
      text = _ref$text === undefined ? null : _ref$text,
      _ref$timestamp = _ref.timestamp,
      timestamp = _ref$timestamp === undefined ? null : _ref$timestamp;

  return (0, _InitialMessage2.default)({
    id: id || (0, _generateUuid.generateUuid)(),
    sender: (0, _immutable.Map)((0, _immutable.fromJS)(sender)),
    status: (0, _Status2.default)(status),
    attachments: (0, _buildAttachments.buildAttachments)(attachments),
    clientType: clientType,
    richText: richText,
    text: text,
    timestamp: timestamp === null ? (0, _timestamps.generateUniqueClientTimestamp)() : timestamp
  });
};